import { useEffect, useRef } from 'react'
import { crossedThresholds } from './scroll-depth'
import { trackScrollDepth, type PageType } from './events'

// Fires scroll_depth at 25/50/75/90% of document scroll, once each per mount.
export function useScrollDepth(pageType: PageType): void {
  const fired = useRef<Set<number>>(new Set())
  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement
      const max = doc.scrollHeight - doc.clientHeight
      if (max <= 0) return
      const percent = Math.round((doc.scrollTop / max) * 100)
      for (const t of crossedThresholds(percent, fired.current)) {
        fired.current.add(t)
        trackScrollDepth({ pageType, percent: t })
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [pageType])
}
